module.exports = ".tab-div {\r\n\theight: 500px;\r\n}"